import { Elevation } from '--components/theme';
import styled, { css, DefaultTheme } from 'styled-components';

interface SurfaceProps {
    elevation?: Elevation
    radius?: keyof DefaultTheme["radius"]
    contrast?: true
    noPadding?: boolean
    noRadius?: boolean
}

const Surface = styled.div<SurfaceProps>`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: ${props => props.noPadding ? 0 : props.theme.spacing(2)};
    position: relative;
    border-radius: ${props => !props.noRadius && props.theme.radius[props.radius || "large"]};

    ${props => {

        let contrastCSS: string = `background: ${props.theme.palette.surface}`;
        if (props.contrast) contrastCSS = `background: ${props.theme.palette.surfaceContrast}`
        switch (props.elevation) {
            case 1:
                return css`box-shadow: ${props.theme.shadows.low}; border: none; ${contrastCSS};`;
            case 2:
                return css`box-shadow: ${props.theme.shadows.high}; border: none; ${contrastCSS};`;
            default:
                return css`border: 1px solid ${props.theme.palette.ui.border}; ${contrastCSS};`
        }
    }};
`;

export default Surface
export { Surface, SurfaceProps }